import React, { useState, useEffect } from "react";
import "./Navbar.css";
import { Link, NavLink } from "react-router-dom";
import logo from '../../logo.svg';
import loginImg from '../../login.svg';
import logoutImg from '../../logout.svg';
import Axios from 'axios';
import { redirect, useNavigate } from "react-router-dom";
import { UserCheck, User } from "lucide-react";
import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'


export const Navbar = (props) => {

    const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  //let navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  //Axios.defaults.withCredentials = true;
  let navigate = useNavigate();

  useEffect(() => {
    const fetchProtected = async () => {
      try {
        const response = await Axios.get('https://mygamename.com/php/protected.php', { withCredentials: true });
        console.log(response);
        if (response.data.status === 'success') {
          //setEmail(response.data.email);
          props.setLoginStatus(true);
          
          props.setUEmail(response.data.email);
        } else {
          props.setLoginStatus(false);
          //window.location.href = '/login';
        }
      } catch (error) {
        console.error(error);
        //window.location.href = '/login';
      }
    };
  
    fetchProtected();
  }, []);

  const logout = () => {
    //localStorage.clear();
    //document.cookie = `token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    Axios.get("https://mygamename.com/php/logout.php").then((response) => {
      props.setLoginStatus(false);
      try {
        props.setUEmail('');
      }catch{

      }
      console.log('logout');
      navigate('/login');
    });
  }
  

  return (
    <nav className="bg-white text-gray">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex-shrink-0">
            <Link to="/" className="title">
                <img src={logo} width="50" height="50" />
            </Link>
          </div>
          <div className="hidden md:flex space-x-4">
            <Link to="/create" className="hover:text-gray-700">
              Create
            </Link>
            <Link to="/names" className="hover:text-gray-700">
              Names
            </Link>
            <Link to="/about" className="hover:text-gray-700">
              About
            </Link>
            
            <Menu as="div" className="relative ml-3">
              <div>
                <MenuButton className="mt-[0.8em] p-[0.25em] relative flex rounded-full bg-gray-200 text-sm focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800 focus:outline-hidden">
                  <span className="absolute -inset-1.5" />
                  <span className="sr-only">Open user menu</span>
                  <User />
                </MenuButton>
              </div>
              <MenuItems
                transition
                className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 ring-1 shadow-lg ring-black/5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
              >
                {/* {props.loginStatus ? <MenuItem><NavLink to="/profile" className="block px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:outline-hidden">Profile</NavLink></MenuItem> : ''}
                {props.loginStatus ? <MenuItem><NavLink to="/settings" className="block px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:outline-hidden">Settings</NavLink></MenuItem> : ''} */}
                <MenuItem className="block px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:outline-hidden">
                {props.loginStatus ? <button onClick={logout}>Logout</button> : <NavLink to="/login"><button>Login</button></NavLink>}
                </MenuItem>
              </MenuItems>
            </Menu>
          </div>
          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="text-gray-700 bg-white hover:text-blue focus:outline-none"
            >
              ☰
            </button>
          </div>
        </div>
      </div>
      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white text-gray">
          <Link
            to="/create"
            onClick={() => setIsOpen(false)}
            className="block px-4 py-2 text-gray-700 hover:bg-gray-200"
          >
            Create
          </Link>
          <Link
            to="/names"
            onClick={() => setIsOpen(false)}
            className="block px-4 py-2 text-gray-700 hover:bg-gray-200"
          >
            Names
          </Link>
          <Link
            to="/About"
            onClick={() => setIsOpen(false)}
            className="block px-4 py-2 text-gray-700 hover:bg-gray-200"
          >
            About
          </Link>
          
          <div
            to="/login"
            onClick={() => setIsOpen(false)}
            className="block px-4 py-2 text-gray-700 hover:bg-gray-200 mt-3"
          >
            {props.loginStatus ? <button onClick={logout}><UserCheck /></button> : <NavLink to="/login"><button><User /></button></NavLink>}
          </div>
        </div>
      )}
    </nav>
  );
};